import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const dialogHeader: SxStyle = {
  borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
};

export const tabPanel: SxStyle = {
  padding: (p) => p.spacing(0),
  paddingTop: (p) => p.spacing(1.5),
};

export const itemsContainer: SxStyle = {
  whiteSpace: 'pre',
};

export const card: SxStyle = {
  height: (p) => p.spacing(16),
};

export const validationInfoItem: SxStyle = {
  height: (p) => p.spacing(3.5),
  borderRadius: (p) => p.spacing(0.5),
  paddingX: (p) => p.spacing(0.5),
  '.copy-to-clipboard-validation-info-item': {
    display: 'none',
  },
  '&:hover': {
    backgroundColor: (p) => p.palette.grey[200],
  },
  ':hover .copy-to-clipboard-validation-info-item': {
    display: 'inline-flex',
  },
};

export const scrollbar: SxStyle = {
  height: (p) => p.spacing(16),
};
